/**
 * Резолв `mdi:xxx` identifier → SVG path data из @mdi/js.
 *
 * Модульные манифесты используют `mdi:xxx` формат (например `mdi:dns`).
 * Встроенные пункты навигации используют уже path из @mdi/js.
 * Этот map содержит все иконки, используемые модулями в их манифестах.
 *
 * Если иконка не найдена — возвращается исходная строка
 * (возможно это уже SVG path data).
 */
import {
    mdiDns,
    mdiVpn,
    mdiAccountGroup,
    mdiCardAccountDetails,
    mdiClipboardList,
    mdiPuzzle,
    mdiChartLine,
    mdiTunnel,
    mdiServerNetwork,
    mdiShieldAccountOutline,
    mdiCube,
    mdiWeb,
    mdiSwordCross,
    mdiMinecraft,
    mdiLock,
    mdiRouterNetwork,
    mdiShieldCheck,
    mdiShieldLock,
    mdiNetwork,
    mdiSwapHorizontal,
    mdiMessageArrowRightOutline
} from '@mdi/js';

const mdiIconMap: Record<string, string> = {
    'mdi:message-arrow-right-outline': mdiMessageArrowRightOutline,
    // DNS module
    'mdi:dns': mdiDns,
    'mdi:server-network': mdiServerNetwork,
    // VPN module
    'mdi:vpn': mdiVpn,
    'mdi:account-group': mdiAccountGroup,
    'mdi:card-account-details': mdiCardAccountDetails,
    'mdi:clipboard-list': mdiClipboardList,
    'mdi:puzzle': mdiPuzzle,
    'mdi:chart-line': mdiChartLine,
    // Tunnels module
    'mdi:tunnel': mdiTunnel,
    // Anubis module
    'mdi:shield-account-outline': mdiShieldAccountOutline,
    'mdi:shield-check': mdiShieldCheck,
    'mdi:shield-lock': mdiShieldLock,
    // ReverseProxy module
    'mdi:web': mdiWeb,
    'mdi:router-network': mdiRouterNetwork,
    'mdi:swap-horizontal': mdiSwapHorizontal,
    // Minecraft module
    'mdi:sword-cross': mdiSwordCross,
    'mdi:minecraft': mdiMinecraft,
    // Fallback
    'mdi:cube': mdiCube,
    'mdi:lock': mdiLock,
    'mdi:network': mdiNetwork
};

/** Преобразует `mdi:xxx` или `mdi-xxx` в path из @mdi/js, или возвращает path как есть. */
export function resolveMdiIcon(icon: string): string {
    // Поддерживаем оба формата: mdi:xxx (манифесты) и mdi-xxx (Fleet catalog)
    const normalized = icon.replace(/^mdi[:]/, '').replace(/^mdi[-]/, '');
    const key = `mdi:${normalized}`;
    if (mdiIconMap[key]) return mdiIconMap[key];
    // Также пробуем с дефисом
    const key2 = `mdi-${normalized}`;
    if (mdiIconMap[key2]) return mdiIconMap[key2];
    return icon;
}
